export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-teal-900 text-white py-16 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/1abbfbd7-97ad-49cf-b76f-1b8793713d8e.png"
              alt="NEMT Services"
              className="h-12 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-sm text-teal-200 leading-relaxed">
              Providing compassionate, reliable non-emergency medical transportation services to help you reach your healthcare appointments safely and comfortably.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-teal-200 uppercase tracking-wider mb-4">
              GET STARTED
            </h3>
            <div className="flex items-center border-b border-teal-700 pb-2">
              <input
                type="text"
                placeholder="Enter your zip code"
                className="bg-transparent text-white placeholder-teal-300 text-sm flex-1 outline-none"
              />
              <button className="text-teal-200 hover:text-white transition-colors cursor-pointer" aria-label="Submit zip code">
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
            <p className="text-xs text-teal-300 mt-2">
              Check our <span className="underline cursor-pointer">service area</span>
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-teal-200 uppercase tracking-wider mb-4">
              QUICK LINKS
            </h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm text-white hover:text-teal-200 transition-colors cursor-pointer">
                  Schedule Appointment
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-white hover:text-teal-200 transition-colors cursor-pointer">
                  Service Areas
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('insurance')} className="text-sm text-white hover:text-teal-200 transition-colors cursor-pointer">
                  FAQs
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-teal-200 uppercase tracking-wider mb-4">
              CONNECT
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-sm text-white hover:text-teal-200 transition-colors cursor-pointer">
                  Facebook
                </a>
              </li>
              <li>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-sm text-white hover:text-teal-200 transition-colors cursor-pointer">
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="tel:4019039036" className="text-sm text-white hover:text-teal-200 transition-colors cursor-pointer">
                  Contact Support
                </a>
              </li>
              <li className="pt-2">
                <p className="text-xs font-bold text-teal-200 uppercase tracking-wider mb-1">Office Address</p>
                <address className="not-italic text-sm text-white leading-relaxed">
                  Otaliems LLC<br />
                  25 Maple Street, Suite 200 #1016<br />
                  Pawtucket, RI
                </address>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-teal-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-teal-300">
              © 2024 NEMT Services. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-teal-300 hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 opacity-5 pointer-events-none">
        <h2 className="text-9xl font-black text-amber-100 tracking-tight text-center" style={{ fontFamily: 'Inter, sans-serif' }}>
          NEMT CARE
        </h2>
      </div>
    </footer>
  );
}
